$(document).ready(function () {
  // script when the variant is changed on pdp start

  function framed_info() {
    if ($(".style").length !== 0) {
      var framed = $(".style.option-selector__btns :checked").attr("value");
      if (
        framed.toLowerCase().includes("framed") ||
        framed.toLowerCase().includes("frame")
      ) {
        if ($(".frame-color.option-selector__btns").length !== 0) {
          var color = $(".frame-color.option-selector__btns :checked").attr(
            "value"
          );
        } else if ($(".frame.option-selector__btns").length !== 0) {
          var color = $(".frame.option-selector__btns :checked").attr("value");
        }
        $(".frame-info").text("With " + color + " frame");
        $(".label-with-info .frame-color").text(color);
        $('fieldset[option-name="size"] .opposing-items .info-icon').show();
        $('fieldset[option-name="sizes"] .opposing-items .info-icon').show();
        $('fieldset[option-name="size"] .opposing-items .dash-icon').addClass(
          "hidden"
        );
        $('fieldset[option-name="sizes"] .opposing-items .dash-icon').addClass(
          "hidden"
        );
      } else {
        $('fieldset[option-name="size"] .opposing-items .info-icon').hide();
        $('fieldset[option-name="sizes"] .opposing-items .info-icon').hide();
        $(
          'fieldset[option-name="size"] .opposing-items .dash-icon'
        ).removeClass("hidden");
        $(
          'fieldset[option-name="sizes"] .opposing-items .dash-icon'
        ).removeClass("hidden");
        $(".frame-info").text("With No Frame");
        var selectedValue = $(".style.option-selector__btns :checked").attr(
          "value"
        );
        $(".label-with-info .frame-color").text(selectedValue);
      }
    } else if ($(".frame").length != 0) {
      var frame_color = $(".frame.option-selector__btns :checked").attr(
        "value"
      );
      if (
        frame_color.toLowerCase().includes("none") ||
        frame_color.toLowerCase().includes("print only")
      ) {
        $('fieldset[option-name="size"] .opposing-items .info-icon').hide();
        $('fieldset[option-name="sizes"] .opposing-items .info-icon').hide();
        $(
          'fieldset[option-name="size"] .opposing-items .dash-icon'
        ).removeClass("hidden");
        $(
          'fieldset[option-name="sizes"] .opposing-items .dash-icon'
        ).removeClass("hidden");
        $(".frame-info").text("With No Frame");
        $(".label-with-info .frame-color").text("Print Only");
      } else {
        $(".frame-info").text("With " + frame_color + " frame");
        $(".label-with-info .frame-color").text(frame_color);
        $('fieldset[option-name="size"] .opposing-items .info-icon').show();
        $('fieldset[option-name="sizes"] .opposing-items .info-icon').show();
        $('fieldset[option-name="size"] .opposing-items .dash-icon').addClass(
          "hidden"
        );
        $('fieldset[option-name="sizes"] .opposing-items .dash-icon').addClass(
          "hidden"
        );
      }
    } else if ($(".color").length != 0) {
      var frame_color = $(".color.option-selector__btns :checked").attr(
        "value"
      );
      if (frame_color.toLowerCase().includes("none")) {
        $('fieldset[option-name="size"] .opposing-items .info-icon').hide();
        $('fieldset[option-name="sizes"] .opposing-items .info-icon').hide();
        $(
          'fieldset[option-name="size"] .opposing-items .dash-icon'
        ).removeClass("hidden");
        $(
          'fieldset[option-name="sizes"] .opposing-items .dash-icon'
        ).removeClass("hidden");
        $(".frame-info").text("With No Frame");
        $(".label-with-info .frame-color").text("Print Only");
      } else {
        $(".frame-info").text("With " + frame_color + " frame");
        $(".label-with-info .frame-color").text(frame_color);
        $('fieldset[option-name="size"] .opposing-items .info-icon').show();
        $('fieldset[option-name="sizes"] .opposing-items .info-icon').show();
        $('fieldset[option-name="size"] .opposing-items .dash-icon').addClass(
          "hidden"
        );
        $('fieldset[option-name="sizes"] .opposing-items .dash-icon').addClass(
          "hidden"
        );
      }
    }
    var frame_size = $(".size.option-selector__btns :checked").attr("value");
    var frame_size_1 = $(".sizes.option-selector__btns :checked").attr("value");
    $(".label-with-info .frame-size").text(frame_size);
    $(".label-with-info .frame-size").text(frame_size_1);
  }
  framed_info();
  $(".option-selector-fieldset").change(function () {
    framed_info();
  });

  // script when the variant is changed on pdp end

  // script to add text for klarma in buy buttons start

  function change_checkout_text() {
    $(".shopify-payment-button__more-options").html(
      "Buy with " +
        "<img class='klarma-image' src='https://cdn.shopify.com/s/files/1/0620/9375/4583/files/Klarna-Logo.png?v=1710849842'>"
    );
  }

  $(".shopify-payment-button__more-options").click(function () {
    change_checkout_text();
  });

  // Select the target node
  var targetNode = document.documentElement; // This represents the entire document

  // Options for the observer (which mutations to observe)
  var config = { childList: true, subtree: true };

  // Callback function to execute when mutations are observed
  var callback = function (mutationsList, observer) {
    for (var mutation of mutationsList) {
      if (mutation.type === "childList") {
        // Check if any added nodes match the selector
        $(mutation.addedNodes)
          .find(".shopify-payment-button__more-options")
          .each(function () {
            change_checkout_text();
            // Do something when the element is added
          });
      }
    }
  };

  // Create an observer instance linked to the callback function
  var observer = new MutationObserver(callback);

  // Start observing the target node for configured mutations
  observer.observe(targetNode, config);

  // Later, you can disconnect the observer if needed
  // observer.disconnect();

  // Select the target node
  var targetNode = document.documentElement; // This represents the entire document

  // Options for the observer (which mutations to observe)
  var config = {
    childList: true,
    subtree: true,
    characterData: true,
    characterDataOldValue: true,
  };

  // Callback function to execute when mutations are observed
  var callback = function (mutationsList, observer) {
    for (var mutation of mutationsList) {
      if (mutation.type === "characterData") {
        // Check if the mutation happened inside .shopify-payment-button__more-options
        if (
          $(mutation.target).closest(".shopify-payment-button__more-options")
            .length > 0
        ) {
          change_checkout_text();
          // Do something when the text changes
        }
      }
    }
  };

  // Create an observer instance linked to the callback function
  var observer = new MutationObserver(callback);

  // Start observing the target node for configured mutations
  observer.observe(targetNode, config);

  // Later, you can disconnect the observer if needed
  // observer.disconnect();

  // script to add text for klarma in buy buttons end

  // script on variant change for framed and print only options start

  function toggle_unavailable() {
    setTimeout(function () {
      $(".size-value-with-list")
        .find("li.size-variant")
        .removeClass("is-unavailable")
        .show();
      $(".size.option-selector__btns")
        .find("input.is-unavailable")
        .each(function () {
          // Get the value of each unavailable radio button
          var curr_value = $(this).attr("value");
          console.log(curr_value);

          // Find the corresponding <li> element in the list and hide it if it matches the radio button value
          $(".list-size-variants").find(`li[value="${curr_value}"]`).hide();
        });
    }, 400);
  }

  function selected_option() {
    setTimeout(function () {
      var selected_option = $(".size.option-selector__btns")
        .find(":checked")
        .attr("value");
      var selected_unit = $(".unit-option.active").data("unit") || "inches";

      if (selected_option) {
        var selectedLi = $(".list-size-variants li.size-variant").filter(
          function () {
            return $(this).attr("value") === selected_option;
          }
        );

        if (selectedLi.length) {
          // Clear existing active, and add active to selected
          $(".list-size-variants li.size-variant").removeClass("active");
          selectedLi.addClass("active");

          const cmText = selectedLi.data("cm");
          const inchText = selectedLi.data("inches");
          const displayText =
            selected_unit === "cm"
              ? '<span class="selected-label">' + label + "</span> "
              : '<span class="selected-dimensions">' + dimension + "</span> ";

          $(".selected-size-option").html(
            displayText +
              ' — <span class="selected-price">' +
              selectedLi.data("price") +
              "</span>"
          );
        }
      }
    }, 400);
  }

  function toggle_options() {
    $(".list-size-variants li.size-variant").click(function () {
      var current_value = $(this).attr("value");
      var selected_unit = $(".unit-option.active").data("unit") || "inches";

      $(".list-size-variants li.size-variant").removeClass("active");
      $(this).addClass("active");

      var displayText =
        selected_unit === "cm" ? $(this).data("cm") : $(this).data("inches");
      $(".selected-size-option").text(displayText);

      $(`.size .opt-btn[value="${current_value}"]`).trigger("click");
      $(`.sizes .opt-btn[value="${current_value}"]`).trigger("click");
    });
  }

  function toggle_dropdown() {
    $(".selected-size-option").click(function (event) {
      event.stopPropagation(); // Prevents document click from firing immediately after toggle

      // Toggle a class to control visibility
      $(".list-size-variants").toggleClass("open");
    });

    $(document).click(function (event) {
      if (
        !$(event.target).closest(".list-size-variants").length &&
        !$(event.target).closest(".selected-size-option").length
      ) {
        // Remove the class to hide the dropdown
        $(".list-size-variants").removeClass("open");
      }
    });
  }

  //   toggle_unavailable();
  //   selected_option();
  //   toggle_options();
  //   toggle_dropdown();

  $('.option-selector-fieldset[option-name="style"]').change(function () {
    setTimeout(function () {
      //   toggle_unavailable();
      //    selected_option();
    }, 100);
  });

  // script on variant change for framed and print only options end
});

// class WiqVariantSizeList extends HTMLElement {
//   constructor() {
//     super();
//     this.positionIndex = parseInt(this.dataset.position);
//     this.productId = this.dataset.productId;
//     this.memberPercentage = parseFloat(this.dataset.memberPercentage);
//     this.unitsEls = this.querySelectorAll("[data-wiq-unit]");
//     this.selectedSizeOptionEl = this.querySelector(
//       "[data-selected-size-option]"
//     );
//     this.sizeUl = this.querySelector(".list-size-variants");
//     this.sizeListEls = Array.from(
//       this.querySelectorAll(".list-size-variants li.size-variant")
//     );
//   }

//   connectedCallback() {
//     this.unit = this.querySelector("[data-wiq-unit].active").dataset.wiqUnit;
//     this.updateUnit(this.unit);

//     this.unitsEls.forEach((unit) => {
//       unit.addEventListener("click", this.handleUnitClick.bind(this));
//     });

//     this.sizeListEls.forEach((sizeListEl) => {
//       sizeListEl.addEventListener("click", this.handleSizeListClick.bind(this));
//     });

//     this.selectedSizeOptionEl.addEventListener("click", () => {
//       this.sizeUl.classList.toggle("open");
//     });

//     document.addEventListener("click", (event) => {
//       if (
//         !this.sizeUl.contains(event.target) &&
//         !this.selectedSizeOptionEl.contains(event.target)
//       ) {
//         this.sizeUl.classList.remove("open");
//       }
//     });
//     document.addEventListener(
//       "wiq-variantChanged",
//       this.handleVariantChanged.bind(this)
//     );
//   }

//   handleUnitClick(event) {
//     const unit = event.currentTarget.dataset.wiqUnit;
//     this.unitsEls.forEach((unitEl) => {
//       if (unitEl.dataset.wiqUnit === unit) {
//         unitEl.classList.add("active");
//       } else {
//         unitEl.classList.remove("active");
//       }
//     });
//     this.updateUnit(unit);
//     this.updateSelectedSizeOption(
//       this.sizeListEls.find((sizeListEl) =>
//         sizeListEl.classList.contains("active")
//       )
//     );
//   }

//   updateUnit(unit) {
//     this.sizeListEls.forEach((sizeListEl) => {
//       sizeListEl.dataset.unitType = unit;
//     });
//   }
//   updateSelectedSizeOption(sizeListEl) {
//     this.selectedSizeOptionEl.innerHTML = `
//       <span class="selected-label">${sizeListEl.dataset.name}</span>
//       <span class="selected-dimensions">${
//         sizeListEl.dataset.unitType === "inches"
//           ? sizeListEl.dataset.inches
//           : sizeListEl.dataset.cm
//       }</span>
//       <span class="selected-price">${
//       sizeListEl.dataset.memberPrice || sizeListEl.dataset.price
//     }</span>
//       `;
//   }

//   updateSizeListPrices(size, variant) {
//     if (!variant) {
//         size.setAttribute("hidden", "");
//         return;
//     }

//     const memberPrice = variant.price * (1 - this.memberPercentage / 100);
    
//     size.dataset.price = Shopify.formatMoney(variant.price, theme.money_format);
//     size.dataset.memberPrice = Shopify.formatMoney(memberPrice, theme.money_format);
    
//     const displayPrice = size.querySelector(".price-display");
//     if (displayPrice) {
//         displayPrice.innerHTML = Shopify.formatMoney(
//             memberPrice,
//             theme.money_format
//         );
//     }
//     size.removeAttribute("hidden");
//   }

//   handleSizeListClick(event) {
//     event.stopPropagation();
//     event.preventDefault();
//     const target = event.currentTarget;
//     const sizeValue = target.dataset.value;
//     this.sizeListEls.forEach((sizeListEl) => {
//       if (sizeListEl.dataset.value === sizeValue) {
//         sizeListEl.classList.add("active");
//       } else {
//         sizeListEl.classList.remove("active");
//       }
//     });
//     this.updateSelectedSizeOption(target);
//     this.sizeUl.classList.remove("open");
//     const sizeOpton = this.closest("fieldset").querySelector(
//       ".opt-btn[value='" + sizeValue + "']"
//     );
//     if (sizeOpton) {
//       sizeOpton.click();
//     }
//   }

//   getVariantByOptions(options, variants) {
//     const variant = variants.find((variant) => {
//       return variant.options.every((option) => options.includes(option));
//     });
//     return variant;
//   }

//   handleVariantChanged(event) {
//     if (!event.detail.variant) {
//       return;
//     }
//     const currentSize = [...event.detail.variant.options][this.positionIndex];

//     this.sizeListEls.forEach((size) => {
//       const options = [...event.detail.variant.options];
//       options[this.positionIndex] = size.dataset.value;
//       const variant = this.getVariantByOptions(
//         options,
//         event.detail.product.variants
//       );
//       this.updateSizeListPrices(size, variant);

//       if (size.dataset.value == currentSize) {
//         size.classList.add("active");
//         this.updateSelectedSizeOption(size);
//       } else {
//         size.classList.remove("active");
//       }
//     });
//   }
// }

// customElements.define("wiq-variant-size-list", WiqVariantSizeList);


class WiqVariantSizeList extends HTMLElement {
  constructor() {
    super();
    this.positionIndex = parseInt(this.dataset.position);
    this.productId = this.dataset.productId;
    this.memberPercentage = parseFloat(this.dataset.memberPercentage);
    this.unitsEls = this.querySelectorAll("[data-wiq-unit]");
    this.selectedSizeOptionEl = this.querySelector(
      "[data-selected-size-option]"
    );
    this.sizeUl = this.querySelector(".list-size-variants");
    this.sizeListEls = Array.from(
      this.querySelectorAll(".list-size-variants li.size-variant")
    );

    // 🔹 Remember last selected size LABEL only
    this.lastSelectedSizeLabel = null;
  }

  connectedCallback() {
    this.unit = this.querySelector("[data-wiq-unit].active").dataset.wiqUnit;
    this.updateUnit(this.unit);

    this.unitsEls.forEach((unit) => {
      unit.addEventListener("click", this.handleUnitClick.bind(this));
    });

    this.sizeListEls.forEach((sizeListEl) => {
      sizeListEl.addEventListener("click", this.handleSizeListClick.bind(this));
    });

    this.selectedSizeOptionEl.addEventListener("click", () => {
      this.sizeUl.classList.toggle("open");
    });

    document.addEventListener("click", (event) => {
      if (
        !this.sizeUl.contains(event.target) &&
        !this.selectedSizeOptionEl.contains(event.target)
      ) {
        this.sizeUl.classList.remove("open");
      }
    });

    document.addEventListener(
      "wiq-variantChanged",
      this.handleVariantChanged.bind(this)
    );
  }

  handleUnitClick(event) {
    const unit = event.currentTarget.dataset.wiqUnit;

    this.unitsEls.forEach((unitEl) => {
      if (unitEl.dataset.wiqUnit === unit) {
        unitEl.classList.add("active");
      } else {
        unitEl.classList.remove("active");
      }
    });

    this.updateUnit(unit);

    const activeSize = this.sizeListEls.find((sizeListEl) =>
      sizeListEl.classList.contains("active")
    );

    if (activeSize) {
      this.updateSelectedSizeOption(activeSize);
    }
  }

  updateUnit(unit) {
    this.sizeListEls.forEach((sizeListEl) => {
      sizeListEl.dataset.unitType = unit;
    });
  }

  updateSelectedSizeOption(sizeListEl) {
    this.selectedSizeOptionEl.innerHTML = `
      <span class="selected-label">${sizeListEl.dataset.name}</span>
      <span class="selected-dimensions">${
        sizeListEl.dataset.unitType === "inches"
          ? sizeListEl.dataset.inches
          : sizeListEl.dataset.cm
      }</span>
      <span class="selected-price">${
        sizeListEl.dataset.memberPrice || sizeListEl.dataset.price
      }</span>
    `;
  }

  updateSizeListPrices(size, variant) {
    if (!variant) {
      size.setAttribute("hidden", "");
      return;
    }

    const memberPrice = variant.price * (1 - this.memberPercentage / 100);

    size.dataset.price = Shopify.formatMoney(
      variant.price,
      theme.money_format
    );

    size.dataset.memberPrice = Shopify.formatMoney(
      memberPrice,
      theme.money_format
    );

    const displayPrice = size.querySelector(".price-display");
    if (displayPrice) {
      displayPrice.innerHTML = Shopify.formatMoney(
        memberPrice,
        theme.money_format
      );
    }

    size.removeAttribute("hidden");
  }

  handleSizeListClick(event) {
    event.stopPropagation();
    event.preventDefault();

    const target = event.currentTarget;
    const sizeValue = target.dataset.value;
    const sizeLabel = target.dataset.name;

    // 🔹 Store only label
    this.lastSelectedSizeLabel = sizeLabel;

    this.sizeListEls.forEach((sizeListEl) => {
      if (sizeListEl.dataset.value === sizeValue) {
        sizeListEl.classList.add("active");
      } else {
        sizeListEl.classList.remove("active");
      }
    });

    this.updateSelectedSizeOption(target);
    this.sizeUl.classList.remove("open");

    const sizeOpton = this.closest("fieldset").querySelector(
      ".opt-btn[value='" + sizeValue + "']"
    );

    if (sizeOpton) {
      sizeOpton.click();
    }
  }

  getVariantByOptions(options, variants) {
    const variant = variants.find((variant) => {
      return variant.options.every((option) => options.includes(option));
    });

    return variant;
  }

  handleVariantChanged(event) {
    if (!event.detail.variant) {
      return;
    }

    const variantOptions = [...event.detail.variant.options];

    const preferredLabel =
      this.lastSelectedSizeLabel ||
      variantOptions[this.positionIndex]?.split(" - ")[0];

    let matchedSizeEl = null;

    this.sizeListEls.forEach((size) => {
      const options = [...variantOptions];
      options[this.positionIndex] = size.dataset.value;

      const variant = this.getVariantByOptions(
        options,
        event.detail.product.variants
      );

      this.updateSizeListPrices(size, variant);

      if (
        size.dataset.name === preferredLabel &&
        variant &&
        !matchedSizeEl
      ) {
        matchedSizeEl = size;
      }

      size.classList.remove("active");
    });

    if (matchedSizeEl) {
      matchedSizeEl.classList.add("active");
      this.updateSelectedSizeOption(matchedSizeEl);

      // 🔥 IMPORTANT: sync Shopify variant selection
      const sizeValue = matchedSizeEl.dataset.value;
      const sizeOptionInput = this.closest("fieldset")?.querySelector(
        ".opt-btn[value='" + sizeValue + "']"
      );

      if (sizeOptionInput) {
        sizeOptionInput.click();
      }
    }
  }
}

customElements.define("wiq-variant-size-list", WiqVariantSizeList);
